import React from 'react';
import moment from 'moment';
import type { ICellRendererParams } from 'ag-grid-community';

import GridCellErrorBoundary from 'components/GridCellErrorBoundary';
import Tooltip from 'components/Tooltip';
import Cell from 'components/V5Gadget/Matrix/Cell';
import KingpinBadge from 'kingpin/atoms/Badge';

import { DriverSetup } from '../driverSetup';

export const SMS_STATUS_CELL = 'SMS_STATUS_CELL';

const SmsStatusCell = ({
  value,
  data,
}: ICellRendererParams<
  DriverSetup.ClientDriver,
  DriverSetup.ClientDriver['smsStatus']
>) => {
  if (!value) {
    return null;
  }

  const unsubscribedTime = data?.smsUnsubscribedTime;
  const tooltipContent =
    value.value === 'UNSUBSCRIBED' && unsubscribedTime
      ? `SMS unsubscribed on ${moment(unsubscribedTime).format('MMM DD, YYYY HH:mm')}`
      : undefined;

  return (
    <Cell>
      <Tooltip content={tooltipContent}>
        <div>
          <KingpinBadge badgeType={value.badgeType} text={value.text} />
        </div>
      </Tooltip>
    </Cell>
  );
};

const Gate = (
  params: ICellRendererParams<
    DriverSetup.ClientDriver,
    DriverSetup.ClientDriver['smsStatus']
  >,
) => (
  <GridCellErrorBoundary
    params={params}
    childComponent={<SmsStatusCell {...params} />}
  />
);

export default Gate;
